import React, {useEffect} from 'react'
import { Link } from 'react-router-dom'
import './Error.css'

import Header from '../../sections/Header/Header'
import Footer from '../../sections/Footer/Footer'

const Error = () => {


    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Header />
            <section className="section-header error-page">
                <div className="view-container">
                    <h1>Not Found <span>404</span></h1>
                    <p>We're sorry, the page you're looking for can't be found. It has either been taken down or is currently being worked on.</p>
                    <div className="city-selector">
                        <Link to={'/'}>Go Back to Our Homepage</Link>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )

}

export default Error;